import { getApiHost } from '@/appSettings';
import { RestManager } from '@/newApi/services/rest/RestManager';
import { queryOptions } from '@tanstack/vue-query';
import { useLoginStore } from '@/login/stores/useLoginStore';

const baseRegistryService = new RestManager(`https://${getApiHost()}/base-registry-service`);

type BaseRegistryOptions = {
    queries: {
        hasDataImported: (enabled?: boolean) => ReturnType<typeof queryOptions<boolean, Error>>,
    },
};

export const baseRegistry: BaseRegistryOptions = {
    queries: {
        hasDataImported: (enabled: boolean = false): ReturnType<typeof queryOptions<boolean, Error>> => {
            const { instance } = useLoginStore();
            const url = `v1/${instance}/base-register/has-data`;
            return queryOptions<boolean, Error>({
                queryKey: ['has-data-imported', instance, url],
                queryFn: async (): Promise<boolean> => {
                    try {
                        const result = await baseRegistryService.post<{ hasData: boolean }>({}, url);
                        return result.hasData;
                    } catch (error) {
                        console.error('Error checking if data is imported', error);
                        throw new Error('Failed to check if data is imported');
                    }
                },
                enabled
            });
        },
    }
};
